import { formatCurrency, carePhaseDefList } from '@shared';

function CarePhaseInfo({ label, months, cost }: { label: string; months: number; cost: number }) {
  return (
    <div className="flex flex-col items-start text-left sm:items-center sm:text-center">
      <p className="text-xs text-gray-600">{label}</p>
      <p className="text-sm font-bold text-gray-800 sm:text-base">{formatCurrency(cost)}</p>
      <p className="text-xs text-gray-500">
        {months} mo ({(months / 12).toFixed(1)} yr)
      </p>
    </div>
  );
}

interface ProjectedCostBannerProps {
  previewClient: Client;
}

export function ProjectedCostBanner({ previewClient }: ProjectedCostBannerProps) {
  return (
    <div
      className="sticky top-0 z-10 bg-white"
      data-testid="projected-ltc-cost-card"
    >
      <div className="mx-auto w-full max-w-4xl py-3 sm:py-4">
        <div className="border-primary-100 bg-primary-50 flex flex-col items-start justify-between gap-3 rounded-xl border px-3 py-4 sm:flex-row sm:items-center sm:gap-4 sm:px-4 sm:py-5">
          {/* Total cost */}
          <div className="flex flex-col">
            <h3 className="text-xs font-semibold uppercase tracking-wider text-gray-600">
              Projected Lifetime LTC Cost
            </h3>
            <p
              className="text-xl font-bold text-gray-900 sm:text-2xl"
              data-testid="projected-ltc-cost-amount"
            >
              {formatCurrency(
                previewClient.allPhaseCosts?.allPhaseInflatedProfessionalShareCost || 0,
              )}
            </p>
            <p className="text-xs text-gray-500">Based on current assumptions</p>
          </div>

          {/* Per-phase breakdown */}
          <div className="flex items-center gap-4 sm:gap-6">
            {carePhaseDefList.map(carePhaseDef => (
              <CarePhaseInfo
                key={carePhaseDef.key}
                label={carePhaseDef.label}
                months={previewClient.phaseCosts?.[carePhaseDef.index]?.phaseCareMonthsNeeded || 0}
                cost={previewClient.phaseCosts?.[carePhaseDef.index]?.phaseInflatedProfessionalShareCost || 0}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
